export default "__VITE_ASSET__CAlpLyox__"